import { Table } from "antd";
import React, { useState } from "react";
import { Cards } from "../../../../components/cards/frame/cards-frame";
import { UserTableStyleWrapper } from "../../../pages/style";
import { TableWrapper } from "../../../styled";
import { AutoComplete } from "../../../../components/autoComplete/autoComplete";
import { filtrujZoznam } from "../../../../utils/hladanie";
import { useZdrzanie } from "../../../../utils/zdrzanie";

const Tab2 = (props) => {
  const { t, carsData } = props;

  // Zoznam si drzime len tu. Predtym sa vozidla majitela ukladali do
  // spolocneho uloziska aut, takze prepisali zoznam na /admin/car.
  const [hladanie, setHladanie] = useState("");
  const hladanyText = useZdrzanie(hladanie, 300);
  const carsTableData = [];

  const zobrazene = filtrujZoznam(carsData, hladanyText, item => [
    item?.licence_plate,
    item?.vin,
    item?.type,
    item?.driver_firstname,
    item?.driver_lastname,
    item?.branchOffice?.company,
    item?.carRenter?.company
  ])

  zobrazene &&
    zobrazene.map((car) => {
      const {
        id,
        driver_firstname,
        driver_lastname,
        licence_plate,
        branchOffice,
        carRenter,
      } = car;
      const company = branchOffice?.company || null;
      const renter = carRenter?.company || null;
      const link = "/admin/car/edit/" + id;
      return carsTableData.push({
        key: id,
        licence_plate: (
          <a key={id} href={link}>
            <span className={`status-text`}>{licence_plate}</span>
          </a>
        ),
        firstname: driver_firstname,
        lastname: driver_lastname,
        company: company,
        renter: renter,
      });
    });

  // Predtym to padalo na aute bez pobocky alebo bez najomcu
  // (item.branchOffice.company na prazdnej vazbe).
  // Text si drzime lokalne a zoznam pocitame z neho. Predtym sa vysledok
  // ukladal do ulozista a pri kazdom prichode dat sa prepisal spat na
  // vsetky auta, takze hladanie vyzeralo, ze nerobi nic.
  const handleSearch = searchText => {
    setHladanie(typeof searchText === 'string' ? searchText : '')
  }

  return (
    <Cards headless>
      <div style={{ marginBottom: "20px" }}>
        <AutoComplete
          onSearch={handleSearch}
          // dataSource={notData}
          placeholder={t("carOwners.startWritting")}
          width="100%"
          patterns
        />
      </div>
      <UserTableStyleWrapper>
        <TableWrapper className="table-responsive">
          <Table
            dataSource={carsTableData}
            columns={getCarsTableColumns(t)}
            pagination={{
              defaultPageSize: 20,
              total: carsTableData ? carsTableData.length : 0,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items"
                )}`,
            }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
    </Cards>
  );
};
const getCarsTableColumns = (t) => {
  return [
    {
      title: t("car.licencePlate"),
      dataIndex: "licence_plate",
      key: "licence_plate",
    },
    {
      title: t("car.company"),
      dataIndex: "company",
      key: "company",
    },
    {
      title: t("car.renter"),
      dataIndex: "renter",
      key: "renter",
    },
    {
      title: t("car.driverFirstname"),
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: t("car.driverLastname"),
      dataIndex: "lastname",
      key: "lastname",
    },
  ];
};
export { Tab2 };
